module.exports = __webpack_public_path__ + "static/media/edit-01.39093df2.svg";